import { OnboardingTaskName } from "types/onboarding";
import {
  CardApplicationStatus,
  EligibilityCriteria,
  EligibilityStatus,
} from "utils/api/cardApplication";

export const getRelevantActionableEligibilityCriteria = (
  cardApplication: CardApplicationStatus
) => {
  const {
    currentTaskName,
    eligibilityResult: { applicationStatus, userActionableCriteria },
  } = cardApplication;

  if (applicationStatus !== EligibilityStatus.requiresAction) return [];
  // If the user has returned to the bank linking step, we should show the normal bank linking screen
  if (currentTaskName === OnboardingTaskName.bankLinking) return [];

  return userActionableCriteria.filter((criterion) => {
    // After bank is linked but before payroll is linked, we only care about resolving positive earnings and non-neo bank.
    // Both can be resolved by linking a different bank account.
    if (currentTaskName === OnboardingTaskName.payrollLinking) {
      return [
        EligibilityCriteria.positiveEarnings,
        EligibilityCriteria.nonNeoBank,
      ].includes(criterion);
    }

    return criterion;
  });
};
